import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./LightSelect.scss";

const LightSelect = ({ onChange, bgColor, inputColor, defaultValue }) => {
  const [switchPosition, setSwitchPosition] = useState("center");
  const [animation, setAnimation] = useState(null);

  const getSwitchAnimation = (value) => {
    let newAnimation = null;
    if (value === "center" && switchPosition === "left") {
      newAnimation = "left-to-center";
    } else if (value === "right" && switchPosition === "center") {
      newAnimation = "center-to-right";
    } else if (value === "center" && switchPosition === "right") {
      newAnimation = "right-to-center";
    } else if (value === "left" && switchPosition === "center") {
      newAnimation = "center-to-left";
    } else if (value === "right" && switchPosition === "left") {
      newAnimation = "left-to-right";
    } else if (value === "left" && switchPosition === "right") {
      newAnimation = "right-to-left";
    }
    onChange(value);
    setSwitchPosition(value);
    setAnimation(newAnimation);
  };

  useEffect(() => {
    switch (defaultValue) {
      case "green":
        getSwitchAnimation("left");
        break;
      case "orange":
        getSwitchAnimation("center");
        break;
      case "red":
        getSwitchAnimation("right");
        break;
      default:
        getSwitchAnimation("center");
        break;
    }
  }, [defaultValue]);

  return (
    <div
      className="toggle-main-container"
      style={{
        backgroundColor: bgColor,
      }}
    >
      <div
        className={`switch ${animation} ${switchPosition}-position`}
        style={{
          backgroundColor: inputColor,
          border: `3px solid ${bgColor}`,
        }}
      />
      {["left", "center", "right"].map((pos) => (
        <React.Fragment key={pos}>
          <input
            onChange={(e) => getSwitchAnimation(e.target.value)}
            name="map-switch"
            id={pos}
            type="radio"
            value={pos}
            checked={switchPosition === pos}
          />
          <label className={`${pos}-label`} htmlFor={pos}></label>
        </React.Fragment>
      ))}
    </div>
  );
};

LightSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  bgColor: PropTypes.string,
  inputColor: PropTypes.string,
  defaultValue: PropTypes.string,
};

LightSelect.defaultProps = {
  bgColor: "#FBF1D6",
  inputColor: "#E79D0E",
  defaultValue: "center",
};

export default LightSelect;
